import { SectionInterface, StoreWallInterface } from "../../types/store";
import {partsProperties} from "../../../shared";

interface getRemoveSectionInterface {
    currentShelving: StoreWallInterface;
    removeSection: SectionInterface
}

export const getRemoveSection = ({ currentShelving, removeSection }: getRemoveSectionInterface) => {

    const replaceSectionIndex = currentShelving.sections.findIndex((section) => section.id === removeSection.id);
    const newSections = [];
    for (let q = 0; q < currentShelving.sections.length; q++) {
        const section = currentShelving.sections[q];
        if (q === replaceSectionIndex) {
            continue
        }
        if (q < replaceSectionIndex) {
            newSections.push(section);
        } else {
            const updatedItemsAfterRemoveSection = section.items.map(item => ({
                ...item,
                position: [item.position[0] - (removeSection.width - partsProperties.railing.vertical.doubleWidth) / 1000, item.position[1], item.position[2]]
            }))
            newSections.push({ ...section, offset: section.offset - (removeSection.width - partsProperties.railing.vertical.doubleWidth), items: updatedItemsAfterRemoveSection });
        }
    }
    return newSections
};
